"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const Clickable_1 = __importDefault(require("./Clickable"));
const ClickableWrapper = (0, react_1.forwardRef)(({ children, isClickable = true, clickableProps = {} }, ref) => {
    if (!isClickable) {
        return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: children });
    }
    return ((0, jsx_runtime_1.jsx)(Clickable_1.default, Object.assign({}, clickableProps, { ref: ref }, { children: children })));
});
exports.default = ClickableWrapper;
